import React, { useState, FormEvent, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';

import { Suggest, ItemRenderer, ItemPredicate } from '@blueprintjs/select';
import { FormGroup, InputGroup, Button, Tabs, Tab, Collapse, HTMLSelect, HTMLTable, ControlGroup, Classes, MenuItem, Alert, Spinner } from "@blueprintjs/core";

import { IconNames } from "@blueprintjs/icons";

import { AxiosInstance } from 'axios';

import * as utils from "./utils";

import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next';

import { Account, Currency, NumData, Environment, Receivable, ReceivableItem, Customer } from './Types'


interface ReceivableViewProps {
    svc: AxiosInstance,
    currentEnv: Environment,
    ar: Receivable,
    baseUrl?: string,
    token?: string | null,
    onNew?: () => void,
    onEdit?: () => void,
    onCopy?: () => void,
    onDelete?: (ar: Receivable) => void,
}

function ReceivableView({ svc, currentEnv, ar = {} as Receivable, baseUrl = "", token = "", onNew = () => {}, onEdit = () => { }, onCopy = () => { }, onDelete = () => { } }: ReceivableViewProps) {
    const { t, i18n } = useTranslation();
    const [isOpenDelete, setIsOpenDelete] = useState(false)

    if (!("voucherCode" in ar)) return null

    let totalDr = ar.dr, totalCr = ar.cr
    for (const item of ar.items) {
        totalDr += item.dr
        totalCr += item.cr
    }

    return (
        <div>
            {/*
            <Dialog icon="help" isOpen={isOpenDelete} canEscapeKeyClose={true} canOutsideClickClose={true} title="AC3x" onClose={() => setIsOpenDelete(false)}>
                <div className="DialogBody">
                    <div className="Spacing-V-16" />
                    <p>Delete voucher {ar.voucherCode}?</p>
                    <div className="Row-4">
                        <Button className="Col-3-1" icon="cross" onClick={() => setIsOpenDelete(false)}>No</Button>
                        <Button className="Col-4-1" icon="tick" intent="danger" onClick={() => {onDelete(ar); setIsOpenDelete(false)}}>DELETE</Button>
                    </div>
                </div>
            </Dialog>
            */}
            <Alert icon="trash" intent="danger" confirmButtonText={t('button_delete')} isOpen={isOpenDelete} onConfirm={() => {onDelete(ar); setIsOpenDelete(false)}} onCancel={() => setIsOpenDelete(false)} cancelButtonText={t('button_no')} canEscapeKeyCancel={true} canOutsideClickCancel={true}>
                <p>{t('confirm_delete_ar', {ar})}</p>
            </Alert>
            <div className="Row">
                <Button className="Col-1-1" icon="add" onClick={() => onNew()}>{t('new')}</Button>
                <Button className="Col-2-1" icon="edit" onClick={() => onEdit()}>{t('edit')}</Button>
                <Button className="Col-3-1" icon="duplicate" onClick={() => onCopy()}>{t('make_copy')}</Button>
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('journal')}>
                    <InputGroup readOnly value={ar.journalCode} />
                </FormGroup>
                <FormGroup className="Col-2-1" label={t('voucher')}>
                    <InputGroup readOnly value={ar.voucherCode} />
                </FormGroup>
                <FormGroup className="Col-3-1" label={t('reference')}>
                    <InputGroup readOnly value={ar.reference} />
                </FormGroup>
                <FormGroup className="Col-4-1" label={t('date')}>
                    <InputGroup readOnly value={ar.txDate} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('customer_code')}>
                    <InputGroup readOnly value={ar.custCode} />
                </FormGroup>
                <FormGroup className="Col-2-2" label={t('customer_name')}>
                    <InputGroup readOnly value={ar.custName} />
                </FormGroup>
            </div>
            <div className="Row">
                {/*
                <FormGroup className="Col-1-1" label={t('tx_type')}>
                    <InputGroup readOnly value={ar.txType} />
                </FormGroup>
                */}
                <FormGroup className="Col-1-1" label={t('invoice_no')}>
                    <InputGroup readOnly value={ar.invNo} />
                </FormGroup>
                <FormGroup className="Col-2-1" label={t('invoice_date')}>
                    <InputGroup readOnly value={ar.invDate} />
                </FormGroup>
                <FormGroup className="Col-3-1" label={t('due_date')}>
                    <InputGroup readOnly value={ar.dueDate} />
                </FormGroup>
            </div>
            <HTMLTable striped interactive condensed>
            <thead>
                <tr>
                    <th className="TCol-ACCode">{t('account')}</th>
                    <th className="TCol-ACName">{t('account_name')}</th>
                    <th className="TCol-Desc">{t('description')}</th>
                    <th className="TCol-ACBalance"><div className="Align-R">{t('dr')}</div></th>
                    <th className="TCol-ACBalance"><div className="Align-R">{t('cr')}</div></th>
                </tr>
            </thead>
            <tbody>
                <tr key={0}>
                        <td className="TCol-ACCode">{ar.acCode}</td>
                        <td className="TCol-ACName">{ar.acName}</td>
                        <td className="TCol-Desc">{ar.description}</td>
                        <td className="TCol-ACBalance"><div className="Align-R">{utils.formatMoney(ar.dr)}</div></td>
                        <td className="TCol-ACBalance"><div className="Align-R">{utils.formatMoney(ar.cr)}</div></td>
                    </tr>
                {ar.items.map((item, i) =>
                    <tr key={i+1}>
                        <td className="TCol-ACCode">{item.acCode}</td>
                        <td className="TCol-ACName">{item.acName}</td>
                        <td className="TCol-Desc">{item.description}</td>
                        <td className="TCol-ACBalance"><div className="Align-R">{utils.formatMoney(item.dr)}</div></td>
                        <td className="TCol-ACBalance"><div className="Align-R">{utils.formatMoney(item.cr)}</div></td>
                    </tr>
                )}
            </tbody>
            <tfoot>
                <tr>
                <td className="TCol-ACCode"></td>
                <td className="TCol-ACName"></td>
                <td className="TCol-Desc"></td>
                <td className="TCol-ACBalance"><div className="Align-R"><b>{utils.formatMoney(totalDr)}</b></div></td>
                <td className="TCol-ACBalance"><div className="Align-R"><b>{utils.formatMoney(totalCr)}</b></div></td>
                </tr>
            </tfoot>
            </HTMLTable>
            <div className="Spacing-V-16" />
            <div className="Row">
                <Button className="Col-1-1" icon="trash" onClick={() => setIsOpenDelete(!isOpenDelete)}>{t('delete')}</Button>
            </div>
        </div>
    )
}

interface ReceivableEditProps {
    svc: AxiosInstance,
    currentEnv: Environment,
    ar?: Receivable,
    ccyList?: Currency[],
    acList?: Account[],
    numList?: NumData[],
    isNew?: boolean,
    onSave: (ar: Receivable, saveAndNew: boolean) => Promise<boolean>,
    onCancel: () => void,
}

function ReceivableEdit({ svc, currentEnv, ar = {} as Receivable, ccyList = [] as Currency[], acList = [] as Account[], numList = [] as NumData[], isNew = false, onSave, onCancel }: ReceivableEditProps) {
    const { t, i18n } = useTranslation();
    const { register, handleSubmit, reset, setValue, getValues } = useForm<Receivable>()

    const defaultItems = "voucherCode" in ar ? ar.items : [{} as ReceivableItem]
    const [items, setItems] = useState(defaultItems)
    const [custList, setCustList] = useState([] as Customer[])
    const defaultAcAr = "voucherCode" in ar ? {acCode: ar.acCode, acName1: ar.acName} as Account : {}
    const [acAr, setAcAr] = useState(defaultAcAr as Account)
    const defaultCust = "voucherCode" in ar ? {custCode: ar.custCode, custName: ar.custName} as Customer : {}
    const [currentCust, setCurrentCust] = useState(defaultCust as Customer)
    const [totalDr, setTotalDr] = useState(0)
    const [totalCr, setTotalCr] = useState(0)

    const onFormChange = () => recalcTotals()
    const recalcTotals = () => {
        let sumDr = 0, sumCr = 0
        sumDr += utils.StringToNum(getValues(`dr`))
        sumCr += utils.StringToNum(getValues(`cr`))
        for (let i = 0; i < items.length; i++) {
            sumDr += utils.StringToNum(getValues(`items[${i}].dr`))
            sumCr += utils.StringToNum(getValues(`items[${i}].cr`))
        }
        setTotalDr(sumDr)
        setTotalCr(sumCr)
    }

    const refreshCustList = async () => {
        if ("envId" in currentEnv) {
            const res = await svc.post('/customerlist');
            //console.log("refreshCustList", res.data.data)
            setCustList(res.data.data)
        }
    }

    useEffect(() => {
        console.log("useEffect [custList]")
    }, [custList])

    useEffect(() => {
        console.log("useEffect [currentEnv]")
        refreshCustList()
    }, [currentEnv])

    useEffect(() => {
        // Call reset to set default values if ar is passed
        //console.log("useEffect ar, reset, setValue, isNew")
        console.log("useEffect []")
        if ("voucherCode" in ar) {
            if (isNew) {
                // default values for new/copied record
                reset({...ar, ...{voucherCode: "", txDate: utils.formatDate(new Date()), invDate: utils.formatDate(new Date()), dueDate: utils.formatDate(new Date()), invNo: "", reference: ""}})
            } else {
                reset(ar)
            }
        }
        recalcTotals()
        /*
        if (isNew) {
            setValue("txType", "I")
            setValue("txDate", utils.formatDate(new Date()))
            setValue("invDate", utils.formatDate(new Date()))
            setValue("dueDate", utils.formatDate(new Date()))
        }
        */
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    //}, [ar, reset, setValue, isNew])

    useEffect(() => {
        // Suggest don't have ref to use with react-hook-form, so register it manually and call setValue when item is selected
        console.log("useEffect [register]")
        register({ name: "txType" })
        //register({ name: "ccyCode" })
        //register({ name: "journalCode" })
        register({ name: "custCode" })
        register({ name: "acCode" })
        items.map((item, i) => {register({ name: `items[${i}].acCode`});return null})
        console.log("register fields")

        if (isNew) {
            console.log("set default values")
            setValue("txType", "I")
            setValue("txDate", utils.formatDate(new Date()))
            setValue("invDate", utils.formatDate(new Date()))
            setValue("dueDate", utils.formatDate(new Date()))
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [register])

    if (!isNew && !("voucherCode" in ar)) return null

    //const onSubmitAndNew = (data: Receivable) => preSave(data, true)
    //const onSubmit = (data: Receivable) => preSave(data, false)
    //const preSave = async (data: Receivable, saveAndNew: boolean = false) => {
    const onSubmit = async (data: Receivable) => {
        //data.dr = 0
        //data.cr = 0
        console.log(Object.assign(data))
        for (let i = data.items?.length-1; i >= 0; i--) {
            //console.log(i, data.items[i] && data.items[i].acCode)
            if (data.items[i] === undefined ||
                data.items[i].acCode === "" ||
                (data.items[i].acCode !== "C" && (data.items[i].dr - data.items[i].cr) === 0) ||
                (data.items[i].acCode === "C" && data.items[i].description === ""  && (data.items[i].dr - data.items[i].cr) === 0)) {
                //console.log("deleting", i)
                data.items.splice(i, 1)
            } else {
                //data.dr += Number(data.items[i].dr)
                //data.cr += Number(data.items[i].cr)
            }
        }
        //console.log("onsubmit called", data)
        let saveAndNew = isNew
        if (await onSave(data, saveAndNew) && saveAndNew) {
            //console.log("saveAndNew resetting form")
            setItems([{} as ReceivableItem])
            setCurrentCust({} as Customer)
            setAcAr({} as Account)
            reset({
                journalCode: data.journalCode,
                voucherCode: "",
                txDate: utils.formatDate(new Date()),
                invDate: utils.formatDate(new Date()),
                dueDate: utils.formatDate(new Date()),
                invNo: "",
                acCode: "",
                acName: "",
                description: "",
                dr: 0,
                cr: 0,
                reference: "",
                items: [{acName: ""}]
            })
            recalcTotals()
            document.getElementsByName(`voucherCode`)[0].focus()
        }
    }

    const onAdd = () => {
        register({ name: `items[${items.length}].acCode`})
        console.log("register", { name: `items[${items.length}].acCode`})
        setItems(items.concat({} as ReceivableItem))
    }

    const acRenderer: ItemRenderer<Account> = (ac, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        //const text = `${ac.acCode} - ${ac.acName1}`;
        const text = `${ac.acCode} ${ac.acName1.length > 0 || ac.acName2.length > 0 ? '-' : ''} ${ac.acName1+ac.acName2}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={ac.acCode}
                key={ac.acCode}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const acPredicate: ItemPredicate<Account> = (query, ac, _index, exactMatch) => {
        const normalizedText = `${ac.acCode} - ${ac.acName1+ac.acName2}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const acValueRenderer = (ac: Account) => {
        return ac.acCode
    }

    const custRenderer: ItemRenderer<Customer> = (cust, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${cust.custCode} - ${cust.custName}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={cust.custCode}
                key={cust.custCode}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const custPredicate: ItemPredicate<Customer> = (query, cust, _index, exactMatch) => {
        const normalizedText = `${cust.custCode} - ${cust.custName}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const custValueRenderer = (cust: Customer) => {
        return cust.custCode
    }

    const createCustDataFromQuery = (query: string) => {
        return {custCode: query.toUpperCase().slice(0, 10), custName: query} as Customer
    }

    const createCustDataRenderer = (
        query: string,
        active: boolean,
        handleClick: React.MouseEventHandler<HTMLElement>,
    ) => (
        <MenuItem
            icon="add"
            text={`Create "${query}"`}
            active={active}
            onClick={handleClick}
            shouldDismissPopover={false}
        />
    );

    const numRenderer: ItemRenderer<NumData> = (num, { handleClick, modifiers, query }) => {
        if (!modifiers.matchesPredicate) {
            return null;
        }
        const text = `${num.group}`;
        return (
            <MenuItem
                active={modifiers.active}
                disabled={modifiers.disabled}
                label={num.group}
                key={num.group}
                onClick={handleClick}
                text={highlightText(text, query)}
            />
        );
    };

    const numPredicate: ItemPredicate<NumData> = (query, num, _index, exactMatch) => {
        const normalizedText = `${num.group}`.toLowerCase();
        const normalizedQuery = query.toLowerCase();

        if (exactMatch) {
            return normalizedText === normalizedQuery;
        } else {
            return normalizedText.indexOf(normalizedQuery) >= 0;
        }
    };

    const numValueRenderer = (num: NumData) => {
        return num.group
    }

    const createNumDataFromQuery = (query: string) => {
        return {type: "J", group: query.toUpperCase(), last: 0} as NumData
    }

    const createNumDataRenderer = (
        query: string,
        active: boolean,
        handleClick: React.MouseEventHandler<HTMLElement>,
    ) => (
        <MenuItem
            icon="add"
            text={`Create "${query}"`}
            active={active}
            onClick={handleClick}
            shouldDismissPopover={false}
        />
    );

    function highlightText(text: string, query: string) {
        let lastIndex = 0;
        const words = query
            .split(/\s+/)
            .filter(word => word.length > 0)
            .map(escapeRegExpChars);
        if (words.length === 0) {
            return [text];
        }
        const regexp = new RegExp(words.join("|"), "gi");
        const tokens: React.ReactNode[] = [];
        while (true) {
            const match = regexp.exec(text);
            if (!match) {
                break;
            }
            const length = match[0].length;
            const before = text.slice(lastIndex, regexp.lastIndex - length);
            if (before.length > 0) {
                tokens.push(before);
            }
            lastIndex = regexp.lastIndex;
            tokens.push(<strong key={lastIndex}>{match[0]}</strong>);
        }
        const rest = text.slice(lastIndex);
        if (rest.length > 0) {
            tokens.push(rest);
        }
        return tokens;
    }

    function escapeRegExpChars(text: string) {
        //return text.replace(/([.*+?^=!:${}()|\[\]\/\\])/g, "\\$1");
        return text.replace(/([.*+?^=!:${}()|\\])/g, "\\$1");
    }

    const handleHotkey = (e: React.KeyboardEvent<HTMLFormElement>) => {
        //console.log(`ctrl:${e.ctrlKey} alt:${e.altKey} shift:${e.shiftKey} meta:${e.metaKey} key:${e.key} keyCode:${e.keyCode}`)

        // ctrl + s
        if (e.ctrlKey && e.keyCode === 83) {
            e.preventDefault()
            //handleSubmit(onSubmitAndNew)()
            handleSubmit(onSubmit)()
        }
    }

    /*<form onSubmit={handleSubmit(onSubmit)}>*/
    return (
        <form onKeyDown={handleHotkey} onChange={onFormChange}>
            <div className="Row">
                <Button className="Col-1-1" icon="cross" onClick={() => onCancel()}>{t('cancel')}</Button>
                {/*!isNew && <Button className="Col-2-1" icon="tick" onClick={handleSubmit(onSubmit)}>{t('save')}</Button>*/}
                {/*isNew && <Button className="Col-2-1" icon="add" onClick={handleSubmit(onSubmitAndNew)}>{t('save')}</Button>*/}
                <Button className="Col-2-1" icon={isNew?"add":"tick"} onClick={handleSubmit(onSubmit)}>{t('save')}</Button>
                {/*<Button className="Col-2-1" icon="undo" onClick={() => reset(ar)}>Reset</Button>*/}
                {/*<Button className="Col-3-1" icon="tick" type="submit">Save</Button>*/}
            </div>
            <div className="Spacing-V-16" />
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('journal')} labelFor="inputJournalCode">
                    {/*
                    {isNew && <Suggest
                        inputProps={{ placeholder: "" }}
                        items={numList}
                        itemRenderer={numRenderer}
                        itemPredicate={numPredicate}
                        inputValueRenderer={numValueRenderer}
                        createNewItemFromQuery={createNumDataFromQuery}
                        createNewItemRenderer={createNumDataRenderer}
                        resetOnClose={true}
                        onItemSelect={(num) => {
                            setValue(`journalCode`, num.group)
                        }}
                    />}
                    {!isNew && <InputGroup readOnly defaultValue={ar.journalCode} />}
                    */}
                    <InputGroup readOnly name="journalCode" defaultValue="AR" inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-2-1" label={t('voucher')} labelFor="inputReceivableCode">
                    <InputGroup readOnly={!isNew} id="inputReceivableCode" name="voucherCode" placeholder={t('auto_generated')} defaultValue={ar.voucherCode} inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-3-1" label={t('reference')} labelFor="inputReference">
                    <InputGroup id="inputReference" name="reference" inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-4-1" label={t('date')} labelFor="inputTxDate">
                    <InputGroup id="inputTxDate" name="txDate" type="date" inputRef={register} />
                </FormGroup>
            </div>
            <div className="Row">
                <FormGroup className="Col-1-1" label={t('customer_code')} labelFor="inputCustCode">
                    {/*<InputGroup id="inputCustCode" name="custCode" inputRef={register} />*/}
                    <Suggest
                        inputProps={{ placeholder: "" }}
                        //defaultSelectedItem={{custCode: ar.custCode, custName: ar.custName} as Customer}
                        selectedItem={currentCust}
                        items={custList}
                        itemRenderer={custRenderer}
                        itemPredicate={custPredicate}
                        inputValueRenderer={custValueRenderer}
                        createNewItemFromQuery={createCustDataFromQuery}
                        createNewItemRenderer={createCustDataRenderer}
                        resetOnClose={true}
                        onItemSelect={(cust) => {
                            if (!custList.find((c) => c.custCode === cust.custCode)) {
                                setCustList(custList.concat(cust))
                            }
                            setCurrentCust(cust)
                            setValue('custCode', cust.custCode)
                            setValue('custName', cust.custName)
                            setValue('description', cust.custName.slice(0, 100-1-getValues('invNo').length )+"-"+getValues('invNo'))
                            //setValue('acCode', )
                            console.log(cust, currentEnv.acReceivable)
                            let ac = acList.find((ac) => ac.acCode === cust.acReceivable)
                            if (!ac) ac = acList.find((ac) => ac.acCode === currentEnv.acReceivable)
                            if (ac) {
                                setAcAr(ac)
                                setValue('acCode', ac.acCode)
                                setValue(`acName`, ac.acName1+ac.acName2)
                            }
                            document.getElementsByName(`invNo`)[0].focus()
                        }}
                    />
                </FormGroup>
                <FormGroup className="Col-2-2" label={t('customer_name')} labelFor="inputCustName">
                    <InputGroup readOnly id="inputCustName" name="custName" inputRef={register} />
                </FormGroup>
            </div>
            <div className="Row">
                {/*
                <FormGroup className="Col-1-1" label={t('tx_type')} labelFor="inputTxType">
                    <InputGroup id="inputTxType" name="txType" inputRef={register} />
                </FormGroup>
                */}
                <FormGroup className="Col-1-1" label={t('invoice_no')} labelFor="inputInvoiceNo">
                    <InputGroup id="inputInvoiceNo" name="invNo" inputRef={register} onChange={() => {setValue('description', getValues('custName').slice(0, 100-1-getValues('invNo').length )+"-"+getValues('invNo'))}} />
                </FormGroup>
                <FormGroup className="Col-2-1" label={t('invoice_date')} labelFor="inputInvoiceDate">
                    <InputGroup id="inputInvoiceDate" name="invDate" type="date" inputRef={register} />
                </FormGroup>
                <FormGroup className="Col-3-1" label={t('due_date')} labelFor="inputDueDate">
                    <InputGroup id="inputDueDate" name="dueDate" type="date" inputRef={register} />
                </FormGroup>
                <Button className="Col-4-1 Button-LabeledFormGroup" icon="add" onClick={onAdd}>{t('add_entry')}</Button>
            </div>
            <HTMLTable striped interactive condensed>
            <thead>
                <th className="TCol-ACCode">{t('account')}</th>
                <th className="TCol-ACName">{t('account_name')}</th>
                <th className="TCol-Desc">{t('description')}</th>
                <th className="TCol-ACBalance"><div className="Align-R">{t('dr')}</div></th>
                <th className="TCol-ACBalance"><div className="Align-R">{t('cr')}</div></th>
            </thead>
            <tbody>
                    <tr>
                        {/*<td className="TCol-ACCode"><InputGroup id="inputAcCode" name={`items[${i}].acCode`} inputRef={register} /></td>*/}
                        <td className="TCol-ACCode">
                            <Suggest
                                inputProps={{ placeholder: "" }}
                                //defaultSelectedItem={acList.find((ac) => ac.acCode === ar.acCode)}
                                selectedItem={acAr}
                                items={acList}
                                itemRenderer={acRenderer}
                                itemPredicate={acPredicate}
                                inputValueRenderer={acValueRenderer}
                                resetOnClose={true}
                                onItemSelect={(ac) => {
                                    setAcAr(ac)
                                    setValue(`acCode`, ac.acCode)
                                    //console.log("setValue", `items[${i}].acCode`, ac.acCode)
                                    setValue(`acName`, ac.acName1+ac.acName2)
                                    //console.log("newItems", newItems)
                                    document.getElementsByName(`description`)[1].focus()
                                }}
                            />
                        </td>
                        <td className="TCol-ACName"><InputGroup readOnly id="inputAcName" name={`acName`} value={ar.acName} inputRef={register} /></td>
                        {/*<td className="TCol-ACName"><InputGroup readOnly id="inputAcName" name={`ar.acName`} inputRef={register} /></td>*/}
                        <td className="TCol-Desc">
                            <InputGroup id="inputDesc" name={`description`} defaultValue={ar.description} inputRef={register} />
                        </td>
                        <td className="TCol-ACBalance"><InputGroup id="inputDr" name={`dr`} defaultValue={utils.numToString(ar.dr)} type="number" inputRef={register} /></td>
                        <td className="TCol-ACBalance"><InputGroup id="inputCr" name={`cr`} defaultValue={utils.numToString(ar.cr)} type="number" inputRef={register} /></td>
                    </tr>
                {items.map((item, i) =>
                    <tr>
                        {/*<td className="TCol-ACCode"><InputGroup id="inputAcCode" name={`items[${i}].acCode`} inputRef={register} /></td>*/}
                        <td className="TCol-ACCode">
                            <Suggest
                                inputProps={{ placeholder: "" }}
                                //defaultSelectedItem={acList.find((ac) => ac.acCode === item.acCode)}
                                selectedItem={{acCode: item.acCode} as Account}
                                items={acList}
                                itemRenderer={acRenderer}
                                itemPredicate={acPredicate}
                                inputValueRenderer={acValueRenderer}
                                resetOnClose={true}
                                onItemSelect={(ac) => {
                                    setValue(`items[${i}].acCode`, ac.acCode)
                                    //console.log("setValue", `items[${i}].acCode`, ac.acCode)
                                    let newItems = Array.from(items)
                                    newItems[i].acCode = ac.acCode
                                    newItems[i].acName = ac.acName1+ac.acName2
                                    //console.log("newItems", newItems)
                                    setItems(newItems)
                                    document.getElementsByName(`items[${i}].description`)[0].focus()
                                }}
                            />
                        </td>
                        <td className="TCol-ACName"><InputGroup readOnly id="inputAcName" name={`items[${i}].acName`} value={items[i].acName} inputRef={register} /></td>
                        {/*<td className="TCol-ACName"><InputGroup readOnly id="inputAcName" name={`items[${i}].acName`} inputRef={register} /></td>*/}
                        <td className="TCol-Desc">
                            <InputGroup id="inputDesc" name={`items[${i}].description`} inputRef={register}
                                onKeyDown={
                                    (e: React.KeyboardEvent<HTMLInputElement>) => {
                                        // ctrl + shift + " (Excel copy above cell)
                                        if (e.ctrlKey && e.shiftKey && e.keyCode === 222) {
                                            e.preventDefault()
                                            setValue(`items[${i}].description`, getValues(`items[${i-1}].description`))
                                        }
                                    }
                                }
                                rightElement={
                                    i > 0 ?
                                        <Button icon="chevron-up" minimal onClick={() => {setValue(`items[${i}].description`, getValues(`items[${i-1}].description`))}}></Button> :
                                        <Button icon="chevron-up" minimal onClick={() => {setValue(`items[${i}].description`, getValues(`description`))}}></Button>
                                }
                            />
                        </td>
                        <td className="TCol-ACBalance"><InputGroup id="inputDr" name={`items[${i}].dr`} type="number" inputRef={register} /></td>
                        <td className="TCol-ACBalance"><InputGroup id="inputCr" name={`items[${i}].cr`} type="number" inputRef={register} /></td>
                    </tr>
                )}
            </tbody>
            <tfoot>
                <tr>
                    <td className="TCol-ACCode"></td>
                    <td className="TCol-ACName"></td>
                    <td className="TCol-Desc"></td>
                    <td className="TCol-ACBalance"><div className="Align-R"><b>{utils.formatMoney(totalDr)}</b></div></td>
                    <td className="TCol-ACBalance"><div className="Align-R"><b>{utils.formatMoney(totalCr)}</b></div></td>
                </tr>
            </tfoot>
            </HTMLTable>
        </form>
    )
}

interface ReceivableMainProps {
    svc: AxiosInstance,
    currentEnv: Environment,
}

/*
const toaster = Toaster.create({
    position: Position.TOP,
})
*/

function ReceivableMain({ svc, currentEnv = {} as Environment }: ReceivableMainProps) {
    let { tabId: defaultTabId = "list", journalCode: defaultJournalCode, voucherCode: defaultReceivableCode }: { tabId: string, journalCode: string, voucherCode: string } = useParams()
    const { t, i18n } = useTranslation();
    const history = useHistory()

    const [isLoading, setIsLoading] = useState(false)
    const [data, setData] = useState([] as Receivable[])

    const [ccyList, setCcyList] = useState([] as Currency[])
    const [acList, setAcList] = useState([] as Account[])
    const [numList, setNumList] = useState([] as NumData[])

    const [searchKey, setSearchKey] = useState("journalCode")
    const [searchValue, setSearchValue] = useState("AR")
    const [searchValue2, setSearchValue2] = useState("")

    const [showFilters, setShowFilters] = useState(true)

    let date = new Date(), y = date.getFullYear(), m = date.getMonth()
    const [searchFrom, setSearchFrom] = useState(utils.formatDate(new Date(y, m-1, 1)))
    const [searchTo, setSearchTo] = useState(utils.formatDate(date))

    const [searchReference, setSearchReference] = useState("")
    const [searchCustomer, setSearchCustomer] = useState("")
    const [searchParty, setSearchParty] = useState("")
    const [searchDesc, setSearchDesc] = useState("")

    const [searchLimit, setSearchLimit] = useState(0)
    const [searchBackward, setSearchBackward] = useState(false)

    const [selectedTabId, setSelectedTabId] = useState("list")
    const [lastTabId, setLastTabId] = useState("list")
    const [currentAR, setCurrentAR] = useState({} as Receivable)

    const [currentMode, setCurrentMode] = useState("show")

    useEffect(() => {
        console.log("useEffect [defaultJournalCode, defaultReceivableCode]")
        if ("envId" in currentEnv && defaultJournalCode && defaultReceivableCode) {
            console.log("show", defaultJournalCode, defaultReceivableCode);
            (async () => {
                try {
                    const res = await svc.post('/arlist',
                        {
                            by: "journalCode",
                            start: defaultJournalCode,
                            voucherCode: defaultReceivableCode,
                            limit: 1,
                        });
        
                    setData(res.data.data)
                    if (res.data.data.length > 0) {
                        setCurrentAR(res.data.data[0])
                    } else {
                        utils.showError(t('no_record'))
                    }
                    //changeTab("list")
                } catch (error) {
                    utils.showError(error)
                }
            })()
        } else {
            //console.log("not show", defaultJournalCode, defaultReceivableCode);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [defaultJournalCode, defaultReceivableCode, svc, currentEnv])

    useEffect(() => {
        setSelectedTabId(defaultTabId)
    }, [defaultTabId])

    const changeTab = (tabId: string) => {
        history.push(`/receivables/${tabId}`)
        setSelectedTabId(tabId)
    }

    /*
    useEffect(() => {
        setSearchFrom(utils.formatDate(new Date(currentEnv.startOfYear)))
        setSearchTo(utils.formatDateMin(new Date(), new Date(currentEnv.endOfYear)))
    }, [currentEnv])
    */

    const refreshNumList = async () => {
        const res = await svc.post('/numlist',
            {
                type: "J",
            });
        setNumList(res.data.data)
    }

    useEffect(() => {
        console.log("useEffect [svc, currentEnv]");
        (async () => {
            try {
                /*
                {
                    const res = await svc.post('/getdates',
                        {});
                    setSearchFrom(res.data.data.startOfYear)
                    setSearchTo(utils.formatDate(new Date()))
                }
                */
                if ("envId" in currentEnv) {
                    refreshNumList()
                    /*
                    const res = await svc.post('/numlist',
                        {
                            type: "J",
                        });
                    setNumList(res.data.data)
                    */
                }
                {
                    const res = await svc.post('/currencylist',
                        {
                            by: "ccyCode",
                            start: "",
                            limit: 0,
                            backward: false,
                            filters: {
                                ccyCode: "",
                            }
                        });
                    setCcyList(res.data.data)
                }
                if ("envId" in currentEnv) {
                    const res = await svc.post('/accountlist',
                        {
                            by: "acCode",
                            start: "",
                            limit: 0,
                            backward: false,
                            filters: {
                                isDetailOnly: true,
                            }
                        });

                    setAcList([{acCode: "C", acName1:"", acName2:""} as Account].concat(res.data.data))
                    //setAcList(res.data.data)
                }
            } catch (error) {
                utils.showError(error)
            }
        })()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [svc, currentEnv])

    /*
    useEffect(() => {
        (async () => {
            try {
                const res = await svc.post('/currencylist',
                    {
                        by: "ccyCode",
                        start: "",
                        limit: 0,
                        backward: false,
                        filters: {
                            ccyCode: "",
                        }
                    });
                setCcyList(res.data.data)
            } catch (error) {
                utils.showError(error)
            }
        })()
    }, [svc])
    */

    const onSubmit = async (e: FormEvent) => {
        e.preventDefault()
        try {
            setIsLoading(true)
            const res = await svc.post('/arlist',
                {
                    by: searchKey,
                    start: searchKey === "journalCode" ? searchValue : searchCustomer,
                    voucherCode: searchKey === "journalCode" ? searchValue2: "",
                    limit: searchLimit,
                    backward: searchBackward,
                    filters: {
                        from: searchFrom,
                        to: searchTo,
                        reference: searchReference,
                        customer: searchParty,
                        desc: searchDesc,
                    }
                });

            setIsLoading(false)
            setData(res.data.data)
            if (res.data.data.length > 0) {
                setCurrentAR(res.data.data[0])
            } else {
                utils.showError(t('no_record'))
            }
            //changeTab("list")
        } catch (error) {
            utils.showError(error)
        }
    }

    const editOnSave = async (ar: Receivable) => {
        try {
            const res = await svc.post('/arupdate', ar)
            utils.showSuccess(t('saved', {key: res.data.data.journalCode+' '+res.data.data.voucherCode}))
            for (let i = 0; i < data.length; i++) {
                if (data[i].journalCode === res.data.data.journalCode && data[i].voucherCode === res.data.data.voucherCode) {
                    data[i] = { ...data[i], ...res.data.data }
                    setData(data)
                    break
                }
            }
            setCurrentAR(res.data.data)
            setCurrentMode("show")
            refreshNumList()
            return true
        } catch (error) {
            utils.showError(error)
            return false
        }
    }

    const newOnSave = async (ar: Receivable, saveAndNew: boolean = false) => {
        try {
            const res = await svc.post('/aradd', ar)
            utils.showSuccess(t('saved', {key: res.data.data.journalCode+' '+res.data.data.voucherCode}))
            setCurrentAR(res.data.data)
            setData(data.concat(res.data.data))
            if (!saveAndNew) setCurrentMode("show")
            refreshNumList()
            return true
        } catch (error) {
            utils.showError(error)
            return false
        }
    }

    const viewOnDelete = async (ar: Receivable) => {
        try {
            //console.log("deleting voucher:", ar)
            const res = await svc.post('/ardelete', ar)
            utils.showSuccess(t('deleted'))
            setData(data.filter(v => !(v.journalCode === res.data.journalCode && v.voucherCode === res.data.voucherCode)))
            setCurrentAR({} as Receivable)
            changeTab("list")
        } catch (error) {
            utils.showError(error)
        }
    }

    // currentMode = show
    let detail = <ReceivableView svc={svc} currentEnv={currentEnv} ar={currentAR} baseUrl={svc.defaults.baseURL} token={localStorage.getItem('token')} onNew={() => {setLastTabId(selectedTabId); setCurrentMode("new")}} onEdit={() => setCurrentMode("edit")} onCopy={() => setCurrentMode("copy")} onDelete={viewOnDelete}></ReceivableView>
    switch (currentMode) {
        case "edit":
            detail = <ReceivableEdit svc={svc} currentEnv={currentEnv} ar={currentAR} ccyList={ccyList} acList={acList} numList={numList} onSave={editOnSave} onCancel={() => setCurrentMode("show")}></ReceivableEdit>
            break
        case "new":
            detail = <ReceivableEdit isNew svc={svc} currentEnv={currentEnv} ccyList={ccyList} acList={acList} numList={numList} onSave={newOnSave} onCancel={() => { setCurrentMode("show"); changeTab(lastTabId) }}></ReceivableEdit>
            break
        case "copy":
            detail = <ReceivableEdit isNew svc={svc} currentEnv={currentEnv} ar={currentAR} ccyList={ccyList} acList={acList} numList={numList} onSave={newOnSave} onCancel={() => { setCurrentMode("show") }}></ReceivableEdit>
            break
    }

    let list = <>
        <div className="Row">
            <Button className="Col-1-1" icon="add" onClick={() => { setLastTabId(selectedTabId); setCurrentMode("new"); changeTab("detail") }}>{t('new')}</Button>
        </div>
        <div className="Spacing-V-16" />
        {isLoading && <Spinner></Spinner>}
        <HTMLTable striped interactive condensed>
            <thead>
                <tr>
                    <th className="TCol-Journal">{t('journal')}</th>
                    <th className="TCol-Voucher">{t('voucher')}</th>
                    <th className="TCol-Reference">{t('reference')}</th>
                    <th className="TCol-Date">{t('date')}</th>
                    <th className="TCol-PartyCode">{t('customer_code')}</th>
                    <th className="TCol-InvoiceNo">{t('invoice_no')}</th>
                    <th className="TCol-Desc">{t('description')}</th>
                    <th className="TCol-ACBalance"><div className="Align-R">{t('amount')}</div></th>
                </tr>
            </thead>
            <tbody>
                {data.map((ar, i) =>
                    <tr key={i} onDoubleClick={() => { changeTab("detail") }}>
                        <td className="TCol-Journal" onClick={() => { setCurrentAR(ar) }}>{ar.journalCode}</td>
                        {/*<td className="TCol-Voucher" onClick={() => { setCurrentAR(ar) }}>{ar.voucherCode}</td>*/}
                        <td className="TCol-Voucher" onClick={() => { setCurrentAR(ar) }}><a target="_blank" href={`#/receivables/detail/${ar.journalCode}/${ar.voucherCode}`}>{ar.voucherCode}</a></td>
                        <td className="TCol-Reference" onClick={() => { setCurrentAR(ar) }}>{ar.reference}</td>
                        <td className="TCol-Date" onClick={() => { setCurrentAR(ar) }}>{ar.txDate}</td>
                        <td className="TCol-PartyCode" onClick={() => { setCurrentAR(ar) }}>{ar.custCode}</td>
                        <td className="TCol-InvoiceNo" onClick={() => { setCurrentAR(ar) }}>{ar.invNo}</td>
                        <td className="TCol-Desc" onClick={() => { setCurrentAR(ar) }}>{ar.description}</td>
                        <td className="TCol-ACBalance" onClick={() => { setCurrentAR(ar) }}><div className="Align-R">{utils.formatMoney(Math.abs(ar.dr - ar.cr))}</div></td>
                    </tr>
                )}
            </tbody>
        </HTMLTable>
    </>

    return (
        <>
            <div style={{fontSize: "21px", fontWeight: 700}}>{t('receivables')}</div>
            <div className="Spacing-V-16"></div>
            <form onSubmit={onSubmit}>
                <div className="Row">
                    <FormGroup className="Col-1-3" label={t('search')} labelFor="inputSearchValue">
                        <ControlGroup fill>
                            <HTMLSelect className={Classes.FIXED} value={searchKey} onChange={utils.handleStringChange(s => setSearchKey(s))}>
                                <option value="journalCode">{t('journal')}</option>
                                <option value="custCode">{t('customer')}</option>
                            </HTMLSelect>
                            {searchKey === "journalCode" && <>
                            <InputGroup
                                id="inputSearchValue"
                                placeholder={t('journal')}
                                readOnly
                                value={searchValue}
                                onChange={utils.handleStringChange(s => setSearchValue(s))}
                                leftIcon="search"
                            />
                            <InputGroup
                                id="inputSearchValue2"
                                placeholder={t('voucher')}
                                value={searchValue2}
                                onChange={utils.handleStringChange(s => setSearchValue2(s))}
                                rightElement={<Button icon={IconNames.ARROW_RIGHT} minimal type="submit"></Button>}
                            />
                            </>}
                            {searchKey === "custCode" &&
                            <InputGroup
                                id="searchCustomer"
                                placeholder={t('customer')}
                                value={searchCustomer}
                                onChange={utils.handleStringChange(s => setSearchCustomer(s))}
                                leftIcon="search"
                                rightElement={<Button icon={IconNames.ARROW_RIGHT} minimal type="submit"></Button>}
                            />}
                        </ControlGroup>
                    </FormGroup>
                    {/*<Checkbox className="Col-4-1 Checkbox-LabeledFormGroup" label="Backward" defaultChecked={searchBackward} onChange={utils.handleBooleanChange(v => setSearchBackward(v))} />*/}
                    {/*<Button className="Col-5-1 Button-LabeledFormGroup" icon="filter" onClick={() => { setShowFilters(!showFilters) }} >Filters</Button>*/}
                </div>
                <Collapse isOpen={showFilters}>
                    <div className="Row">
                        <FormGroup className="Col-1-1" label={t('from')} labelFor="searchFrom">
                            <InputGroup id="searchFrom" type="date" value={searchFrom} onChange={utils.handleStringChange(s => setSearchFrom(s))} />
                        </FormGroup>
                        <FormGroup className="Col-2-1" label={t('to')} labelFor="searchTo">
                            <InputGroup id="searchTo" type="date" value={searchTo} onChange={utils.handleStringChange(s => setSearchTo(s))} />
                        </FormGroup>
                        <FormGroup className="Col-3-1" label={t('reference')} labelFor="searchReference">
                            <InputGroup id="searchReference" value={searchReference} onChange={utils.handleStringChange(s => setSearchReference(s))} />
                        </FormGroup>
                        <FormGroup className="Col-4-1" label={t('party')} labelFor="searchParty">
                            <InputGroup id="searchParty" value={searchParty} onChange={utils.handleStringChange(s => setSearchParty(s))} />
                        </FormGroup>
                        {/*
                        <div className="Col-4-2 Col-H">
                            <FormGroup label="Limit" labelFor="searchLimit" >
                                <InputGroup className="Input-XS" id="searchLimit" value={searchLimit.toString()} onChange={utils.handleNumberChange(n => setSearchLimit(n))} />
                            </FormGroup>
                        </div>
                        */}
                    </div>
                    <div className="Row">
                        <FormGroup className="Col-1-3" label={t('description')} labelFor="searchDesc">
                            <InputGroup id="searchDesc" value={searchDesc} onChange={utils.handleStringChange(s => setSearchDesc(s))} />
                        </FormGroup>
                    </div>
                </Collapse>
            </form>
            <Tabs onChange={(newTabId) => changeTab(newTabId as string)} selectedTabId={selectedTabId}>
                <Tab id="list" title={t('list')} panel={list} />
                <Tab id="detail" title={t('detail')} panel={detail} />
            </Tabs>
        </>
    );
}

export default ReceivableMain